export default __webpack_public_path__ + "static/media/logo-react.ccbd9d34.png";